import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="bg-[#1C1C1A] text-[#F7F5F2] px-6 md:px-10 pt-24 pb-10"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-14 border-b border-[#F7F5F2]/15 pb-14">
        <div className="md:col-span-8">
          <h3 className="font-serif font-light leading-[0.9] text-6xl md:text-8xl tracking-[-0.02em]">
            You Dream,
            <br />
            <span className="italic text-[#E5D5C1]">We Create.</span>
          </h3>
          <p className="mt-8 font-sans text-sm max-w-md text-[#F7F5F2]/70">
            A family-owned atelier crafting exclusive pieces with love, soul and
            25+ years of quiet expertise.
          </p>
        </div>

        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.3em] font-sans text-[#E5D5C1]/70 mb-5">
            Follow us
          </p>
          <ul className="space-y-3 font-serif text-xl">
            <li>
              <a
                href="https://www.instagram.com/diamant_jewellers?igsh=MWMwdDI4YTVubWQ0bQ=="
                target="_blank"
                rel="noreferrer noopener"
                className="link-underline"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer noopener"
                className="link-underline"
              >
                Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[10px] uppercase tracking-[0.28em] font-sans text-[#F7F5F2]/60">
        <span>© {new Date().getFullYear()} Diamant Jewellers — All rights reserved</span>
        <span>Designed with love · Handmade in the atelier</span>
      </div>
    </footer>
  );
}
